/* DripConnect — Product Detail Page JS */
(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return [...(ctx || document).querySelectorAll(sel)]; }
  function escHtml(s) { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  /* Storewide sale toggle, mirrored from settings.sale_event_active by
     dc-product.liquid. Gates every "was"/"Save"/compare-at price this file
     renders, so JS-built markup matches what Liquid renders server-side. */
  function saleEventActive() { return window.DC_SALE_EVENT === true; }

  function money(cents) {
    const dollars = cents / 100;
    return '$' + dollars.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  /* ── SVG icon strings (inlined for button updates) ─────────── */
  const IC = {
    check: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" style="flex-shrink:0"><path d="M20 6 9 17l-5-5"/></svg>',
    minus: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><path d="M5 12h14"/></svg>',
    plus:  '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><path d="M5 12h14"/><path d="M12 5v14"/></svg>',
  };

  /* ── Product page lightbox (two-element simultaneous slide) ─── */
  let _lb = null;
  function _buildLightbox() {
    const el = document.createElement('div');
    el.id = 'dc-lightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Product image');
    el.innerHTML =
      '<button id="dc-lb-close" type="button" aria-label="Close image">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round">' +
          '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>' +
        '</svg>' +
      '</button>' +
      '<div id="dc-lb-track2">' +
        '<img id="dc-lb-img" src="" alt="">' +
        '<img id="dc-lb-img2" src="" alt="">' +
      '</div>' +
      '<div id="dc-lb-dots2"></div>';
    document.body.appendChild(el);

    const img1    = el.querySelector('#dc-lb-img');
    const img2    = el.querySelector('#dc-lb-img2');
    const dotsEl  = el.querySelector('#dc-lb-dots2');
    const closeBtn = el.querySelector('#dc-lb-close');
    const DUR = 'transform 0.28s cubic-bezier(0.25,0.1,0.25,1)';

    const _lbLowPower = Number(navigator.hardwareConcurrency) <= 2 || Number(navigator.deviceMemory) <= 2;
    if (!_lbLowPower) {
      img1.style.willChange = 'transform';
      img2.style.willChange = 'transform';
    }

    let images = [], idx = 0;
    let tx0 = 0, ty0 = 0, dragging = false, swipeDir = 0;

    function updateDots() {
      dotsEl.innerHTML = images.length <= 1 ? '' :
        images.map((_, i) => `<span class="dc-lb-dot-pdp${i === idx ? ' active' : ''}"></span>`).join('');
    }
    function close() {
      el.classList.remove('open');
      const lockY = parseInt(el.dataset.lockY || '0', 10);
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, lockY);
    }

    closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && el.classList.contains('open')) close(); });
    el.addEventListener('click', e => {
      if (e.target === el) close();
    });

    el.addEventListener('touchstart', e => {
      if (e.touches.length > 1) return;
      tx0 = e.touches[0].clientX; ty0 = e.touches[0].clientY;
      dragging = true; swipeDir = 0;
      img1.style.transition = img2.style.transition = 'none';
    }, { passive: true });

    el.addEventListener('touchmove', e => {
      e.preventDefault();
      if (!dragging) return;
      const dx = e.touches[0].clientX - tx0;
      const vw = el.offsetWidth || window.innerWidth;
      const fwd = dx < 0;
      const adj = fwd ? idx + 1 : idx - 1;
      const hasAdj = adj >= 0 && adj < images.length;
      const dir = fwd ? 1 : -1;
      if (hasAdj && swipeDir !== dir) {
        swipeDir = dir;
        img2.src = images[adj];
        img2.style.transform = `translateX(${fwd ? vw : -vw}px)`;
      }
      img1.style.transform = `translateX(${hasAdj ? dx : dx * 0.15}px)`;
      if (hasAdj) img2.style.transform = `translateX(${(fwd ? vw : -vw) + dx}px)`;
    }, { passive: false });

    el.addEventListener('touchend', e => {
      if (!dragging) return;
      dragging = false;
      const dx = e.changedTouches[0].clientX - tx0;
      const dy = Math.abs(e.changedTouches[0].clientY - ty0);
      const vw = el.offsetWidth || window.innerWidth;
      const fwd = dx < 0;
      const nxt = fwd ? idx + 1 : idx - 1;
      if (Math.abs(dx) > 70 && dy < 120 && nxt >= 0 && nxt < images.length) {
        // Commit index immediately so rapid swipes read the correct value
        idx = nxt;
        img1.style.transition = img2.style.transition = DUR;
        img1.style.transform = `translateX(${fwd ? -vw : vw}px)`;
        img2.style.transform = 'translateX(0)';
        setTimeout(() => {
          img1.src = img2.src;
          img1.style.transition = img2.style.transition = 'none';
          img1.style.transform = 'translateX(0)';
          const nextAdj = fwd ? idx + 1 : idx - 1;
          img2.src = nextAdj >= 0 && nextAdj < images.length ? images[nextAdj] : '';
          img2.style.transform = `translateX(${fwd ? vw : -vw}px)`;
          updateDots();
        }, 300);
      } else {
        img1.style.transition = img2.style.transition = DUR;
        img1.style.transform = 'translateX(0)';
        img2.style.transform = `translateX(${fwd ? vw : -vw}px)`;
      }
    }, { passive: true });

    return {
      open(newImages, newIdx) {
        images = newImages;
        idx = newIdx;
        const vw = el.offsetWidth || window.innerWidth;
        img1.style.transition = img2.style.transition = 'none';
        img1.style.transform = 'translateX(0)';
        img1.src = images[idx];
        const nextAdj = idx + 1 < images.length ? idx + 1 : idx > 0 ? idx - 1 : -1;
        img2.src = nextAdj >= 0 ? images[nextAdj] : '';
        img2.style.transform = `translateX(${vw}px)`;
        updateDots();
        const lockY = window.scrollY;
        el.dataset.lockY = lockY;
        el.classList.add('open');
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${lockY}px`;
        document.body.style.width = '100%';
      }
    };
  }

  /* ── Gallery ────────────────────────────────────────────────── */
  // Tracks document-level listeners across re-instantiation (e.g. theme-editor section re-render)
  // so they can be torn down instead of accumulating.
  let galleryListenerCleanups = [];
  function clearGalleryListeners() {
    galleryListenerCleanups.forEach(fn => fn());
    galleryListenerCleanups = [];
  }
  function isTypingTarget(el) {
    return !!(el && el.matches && el.matches('input, textarea, select, [contenteditable="true"]'));
  }

  class Gallery {
    constructor(el, images) {
      clearGalleryListeners();

      this.el = el;
      this.images = images;
      this.idx = 0;
      this.zoomed = false;

      this.mainArea = qs('[data-pdp-main-area]', el);
      this.mainImg  = qs('[data-pdp-main-img]', el);
      this.thumbs   = qsa('[data-thumb-idx]', el);
      this.bottomBar  = qs('[data-pdp-bottom-bar]', el);
      this.zoomHint   = qs('[data-pdp-zoom-hint]', el);
      this.labelEl    = qs('[data-pdp-img-label]', el);
      this.countText  = qs('[data-pdp-count-text]', el);

      this._setLabel(0);
      this._bindThumbs();
      this._bindZoom();
      this._bindNav();
      this._bindKeyboard();
    }

    _setLabel(idx) {
      if (this.labelEl && this.images[idx]) {
        this.labelEl.textContent = (this.images[idx].label || '').toUpperCase();
      }
      if (this.countText) {
        this.countText.textContent = `${idx + 1} / ${this.images.length}`;
      }
    }

    setActive(idx) {
      this.idx = idx;
      const data = this.images[idx];
      if (!data) return;

      this._setLabel(idx);

      this.thumbs.forEach(t => {
        t.classList.toggle('pdp-gallery__thumb--on', +t.dataset.thumbIdx === idx);
      });

      // Preload new image in parallel with fade-out; swap only when both done.
      // This prevents the old-image flash caused by browsers using the previous
      // src as a placeholder while the new src is still loading.
      const el = this.mainImg;
      const gen = (this._gen = (this._gen || 0) + 1);

      el.style.transition = 'opacity 0.2s ease';
      el.style.opacity = '0';

      let fadeDone = false;
      let loadDone = false;
      const trySwap = () => {
        if (this._gen !== gen || !fadeDone || !loadDone) return;
        el.src = data.src;
        el.alt = data.label || '';
        el.style.opacity = '1';
      };

      const markFade = () => { fadeDone = true; trySwap(); };
      el.addEventListener('transitionend', function h(e) {
        if (e.propertyName !== 'opacity') return;
        el.removeEventListener('transitionend', h);
        markFade();
      });
      setTimeout(markFade, 220);

      const preload = new Image();
      preload.onload = preload.onerror = () => { loadDone = true; trySwap(); };
      preload.src = data.src;
    }

    _bindThumbs() {
      this.thumbs.forEach(t => {
        t.addEventListener('click', () => this.setActive(+t.dataset.thumbIdx));
      });
    }

    _bindZoom() {
      if (!this.mainArea) return;

      const isTouch = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
      if (isTouch) {
        this.mainArea.addEventListener('click', () => {
          const srcs = this.images.map(img => (img.src || '').replace(/width=\d+/, 'width=1800'));
          Gallery._openLightbox(srcs, this.idx);
        });
        return;
      }

      // Desktop: pan-to-zoom
      this.mainArea.addEventListener('click', () => this._toggleZoom());
      this.mainArea.addEventListener('mouseleave', () => {
        if (this.zoomed) this._resetZoomOrigin();
      });
      this.mainArea.addEventListener('mousemove', e => {
        if (!this.zoomed) return;
        const r = this.mainArea.getBoundingClientRect();
        const x = ((e.clientX - r.left) / r.width * 100).toFixed(1);
        const y = ((e.clientY - r.top) / r.height * 100).toFixed(1);
        this.mainImg.style.transformOrigin = `${x}% ${y}%`;
      });
      const onEscKey = e => {
        if (e.key === 'Escape' && this.zoomed) this._zoom(false);
      };
      document.addEventListener('keydown', onEscKey);
      galleryListenerCleanups.push(() => document.removeEventListener('keydown', onEscKey));
    }

    _toggleZoom() { this._zoom(!this.zoomed); }

    _resetZoomOrigin() {
      this.mainImg.style.transformOrigin = '50% 50%';
    }

    _zoom(on) {
      this.zoomed = on;
      this.mainArea.classList.toggle('pdp-gallery__main--zoomed', on);
      if (on) {
        this.mainImg.style.transform = 'scale(2.5)';
        this.mainImg.style.transition = 'transform 0.08s ease';
        if (this.bottomBar) this.bottomBar.hidden = true;
        if (this.zoomHint)  this.zoomHint.textContent = 'Click to exit zoom';
      } else {
        this._resetZoomOrigin();
        this.mainImg.style.transform = 'scale(1)';
        this.mainImg.style.transition = 'transform 0.38s var(--ease-lux)';
        if (this.bottomBar) this.bottomBar.hidden = false;
        if (this.zoomHint)  this.zoomHint.textContent = 'Click to zoom';
      }
    }

    _bindNav() {
      const prev = qs('[data-pdp-prev]', this.el);
      const next = qs('[data-pdp-next]', this.el);
      if (prev) prev.addEventListener('click', e => {
        e.stopPropagation();
        this.setActive((this.idx - 1 + this.images.length) % this.images.length);
      });
      if (next) next.addEventListener('click', e => {
        e.stopPropagation();
        this.setActive((this.idx + 1) % this.images.length);
      });

      // Touch swipe on the main image area
      if (!this.mainArea) return;
      let tx0 = 0, ty0 = 0;
      this.mainArea.addEventListener('touchstart', e => {
        tx0 = e.touches[0].clientX;
        ty0 = e.touches[0].clientY;
      }, { passive: true });
      this.mainArea.addEventListener('touchend', e => {
        const dx = e.changedTouches[0].clientX - tx0;
        const dy = e.changedTouches[0].clientY - ty0;
        if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
        // Suppress the click event that follows touchend so the lightbox doesn't open
        this.mainArea.addEventListener('click', e2 => { e2.stopPropagation(); e2.preventDefault(); }, { capture: true, once: true });
        if (dx < 0) this.setActive((this.idx + 1) % this.images.length);
        else        this.setActive((this.idx - 1 + this.images.length) % this.images.length);
      }, { passive: true });
    }

    _bindKeyboard() {
      const onArrowKey = e => {
        if (isTypingTarget(document.activeElement)) return;
        if (e.key === 'ArrowLeft')
          this.setActive((this.idx - 1 + this.images.length) % this.images.length);
        if (e.key === 'ArrowRight')
          this.setActive((this.idx + 1) % this.images.length);
      };
      document.addEventListener('keydown', onArrowKey);
      galleryListenerCleanups.push(() => document.removeEventListener('keydown', onArrowKey));
    }

    static _openLightbox(srcs, startIdx = 0) {
      if (!_lb) {
        const stale = document.getElementById('dc-lightbox');
        if (stale) stale.remove();
        _lb = _buildLightbox();
      }
      _lb.open(srcs, startIdx);
    }
  }

  /* ── Accordion ──────────────────────────────────────────────── */
  class Accordion {
    constructor(el) {
      this.el   = el;
      this.btn  = qs('[data-pdp-acc-btn]', el);
      this.body = qs('[data-pdp-acc-body]', el);
      this.icon = qs('[data-pdp-acc-icon]', el);
      if (!this.btn || !this.body) return;
      this.btn.addEventListener('click', () => this.toggle());
    }

    toggle() {
      const open = this.body.hidden;
      this.body.hidden = !open;
      if (this.icon) this.icon.innerHTML = open ? IC.minus : IC.plus;
    }
  }

  /* ── Main product controller ────────────────────────────────── */
  class DCProduct {
    constructor(section) {
      this.section = section;

      // Parse server-rendered data
      const varEl  = qs('[data-pdp-variants]', section);
      const imgEl  = qs('[data-pdp-images]', section);
      this.variants       = varEl  ? JSON.parse(varEl.textContent)  : [];
      this.images         = imgEl  ? JSON.parse(imgEl.textContent)   : [];
      this.numOptions     = parseInt(section.dataset.numOptions || '1', 10);
      this.isSingleVar    = section.dataset.singleVariant === 'true';
      this.selectedOptions = {};
      this.currentVariant  = null;
      this.wished = false;
      this.added  = false;

      this._initGallery();
      this._initOptions();
      this._initAccordions();
      this._initActions();
      this._initStickyBar();
      this._loadVendorRecs();

      // Auto-select single-variant products
      if (this.isSingleVar && this.variants.length > 0) {
        this.currentVariant = this.variants[0];
        const avail = this.currentVariant.available !== false;
        this._setAddEnabled(avail, !avail);
      }
    }

    /* ── Gallery ──────────────────────────────────────────────── */
    _initGallery() {
      const el = qs('[data-pdp-gallery]', this.section);
      if (!el || this.images.length === 0) return;
      this.gallery = new Gallery(el, this.images);
      // Hide counter for single images
      if (this.images.length <= 1) {
        const counter = qs('[data-pdp-counter]', el);
        if (counter) counter.hidden = true;
      }
    }

    /* ── Option chips ─────────────────────────────────────────── */
    _initOptions() {
      // Main panel chips
      qsa('[data-pdp-chip]', this.section).forEach(chip => {
        const pos = chip.dataset.optionPosition;
        const val = chip.dataset.pdpChip;
        const avail = this.variants.some(v => v['option' + pos] === val && v.available !== false);
        if (!avail) chip.classList.add('pdp-size-chip--sold-out');
        chip.addEventListener('click', () => this._selectOpt(pos, val));
      });
      // Sticky bar chips
      qsa('[data-pdp-sticky-chip]', this.section).forEach(chip => {
        const pos = chip.dataset.optionPosition;
        const val = chip.dataset.pdpStickyChip;
        const avail = this.variants.some(v => v['option' + pos] === val && v.available !== false);
        if (!avail) chip.classList.add('pdp-sticky-size--sold-out');
        chip.addEventListener('click', () => this._selectOpt(pos, val));
      });
    }

    _selectOpt(pos, val) {
      this.selectedOptions[pos] = val;

      // Sync all chip groups
      qsa('[data-pdp-chip]', this.section).forEach(c => {
        if (c.dataset.optionPosition === pos) {
          c.classList.toggle('pdp-size-chip--on', c.dataset.pdpChip === val);
        }
      });
      qsa('[data-pdp-sticky-chip]', this.section).forEach(c => {
        if (c.dataset.optionPosition === pos) {
          c.classList.toggle('on', c.dataset.pdpStickyChip === val);
        }
      });

      // Update label: "SELECT SIZE: L"
      const selectedSpan = qs('[data-pdp-size-selected]', this.section);
      if (selectedSpan) {
        selectedSpan.textContent = `: ${val}`;
        selectedSpan.hidden = false;
      }
      // Hide "select a size to continue" hint
      const req = qs('[data-pdp-size-req]', this.section);
      if (req) req.hidden = true;

      // Match variant
      const variant = this._findVariant();
      if (variant) {
        this.currentVariant = variant;
        this._updatePrice(variant);
        this._setAddEnabled(variant.available !== false, variant.available === false);
      } else {
        this._setAddEnabled(false, true);
      }
    }

    _findVariant() {
      if (Object.keys(this.selectedOptions).length < this.numOptions) return null;
      return this.variants.find(v =>
        Object.entries(this.selectedOptions).every(
          ([pos, val]) => v['option' + pos] === val
        )
      );
    }

    _updatePrice(variant) {
      const priceEl  = qs('[data-pdp-price]', this.section);
      const wasEl    = qs('[data-pdp-was]', this.section);
      const saveEl   = qs('[data-pdp-save]', this.section);
      const sPriceEl = qs('[data-pdp-sticky-price]', this.section);

      if (priceEl)  priceEl.textContent  = money(variant.price);
      if (sPriceEl) sPriceEl.textContent = money(variant.price);

      const onSale = saleEventActive() && variant.compare_at_price && variant.compare_at_price > variant.price;
      if (wasEl)  { wasEl.textContent  = onSale ? money(variant.compare_at_price) : ''; wasEl.hidden  = !onSale; }
      if (saveEl) { saveEl.textContent = onSale ? `Save ${money(variant.compare_at_price - variant.price)}` : ''; saveEl.hidden = !onSale; }
    }

    _setAddEnabled(enabled, soldOut = false) {
      const addBtn = qs('[data-pdp-add]', this.section);
      [addBtn, qs('[data-pdp-sticky-add]', this.section)]
        .filter(Boolean)
        .forEach(btn => {
          btn.classList.toggle('disabled', !enabled);
          btn.disabled = !enabled;
        });
      const sizeHint = qs('.pdp-size-hint', this.section);
      if (sizeHint) sizeHint.hidden = soldOut;
      const remindWrap = qs('[data-pdp-remind-wrap]', this.section);
      if (remindWrap) {
        remindWrap.hidden = !soldOut;
        if (addBtn) addBtn.hidden = soldOut;
        const stickyAdd = qs('[data-pdp-sticky-add]', this.section);
        if (stickyAdd) stickyAdd.hidden = soldOut;
        // Always reset inner states — covers both transitions (in→out and out→different-out)
        const form = qs('[data-pdp-remind-form]', this.section);
        const remindBtn = qs('[data-pdp-remind]', this.section);
        const success = qs('[data-pdp-remind-success]', this.section);
        // The error has to be reset alongside the success state. It only became reachable once
        // failures started being reported honestly, and a stale "Something went wrong" left
        // sitting under a freshly reset card belongs to a request the shopper never made.
        const error = qs('[data-pdp-remind-error]', this.section);
        if (form) form.hidden = true;
        if (remindBtn) remindBtn.hidden = false;
        if (success) success.hidden = true;
        if (error) error.hidden = true;
      }
    }

    /* ── Accordions ───────────────────────────────────────────── */
    _initAccordions() {
      qsa('[data-pdp-acc]', this.section).forEach(el => new Accordion(el));
    }

    /* ── Add to bag + remind me ─────────────────────────────────── */
    _initActions() {
      const add = qs('[data-pdp-add]', this.section);
      if (add) add.addEventListener('click', () => this._handleAdd());

      const sAdd = qs('[data-pdp-sticky-add]', this.section);
      if (sAdd) sAdd.addEventListener('click', () => this._handleAdd());

      const remindBtn = qs('[data-pdp-remind]', this.section);
      if (remindBtn) {
        remindBtn.addEventListener('click', () => {
          remindBtn.hidden = true;
          const form = qs('[data-pdp-remind-form]', this.section);
          if (form) {
            form.hidden = false;
            qs('[data-pdp-remind-input]', this.section)?.focus();
          }
        });
      }

      const remindSubmit = qs('[data-pdp-remind-submit]', this.section);
      if (remindSubmit) {
        const form   = qs('[data-pdp-remind-form]', this.section);
        const iframe = qs('[data-pdp-remind-iframe]', this.section);

        // What this can and cannot know. Every page on this store is served
        // `x-frame-options: DENY` and `frame-ancestors 'none'`, so the response inside the post
        // target is unreadable no matter what it says — reading its URL always throws, which is
        // how the previous version managed to report "Request received" for every submission,
        // delivered or not. What *is* observable is: the form carried a captcha token when it
        // posted, and a response came back. Either one absent is exactly how it fails:
        //   - no token → Shopify answers 400 and the request is lost
        //   - no load  → the request never left the browser (blocked, or offline)
        // Shopify's captcha-bootstrap covers this form: its selector list includes
        // ['contact','contact'], i.e. form[action*='/contact'] input[name='form_type'][value='contact'],
        // and it binds on the first focusin/change inside the form.
        const isTokenised = () =>
          form?.dataset.hcaptchaBound === 'true' || form?.dataset.recaptchaBound === 'true';

        let attempt      = 0;      // bumped once per request the shopper starts
        let settledFor   = 0;      // the last attempt that produced a result
        let frameArmed   = false;  // false until we have actually posted, so the hidden iframe's
                                   // initial about:blank load can't be mistaken for a response
        let frameTrusted = false;  // whether the post that armed it carried a captcha token
        let remindTimer  = null;

        const finish = (forAttempt, ok) => {
          if (forAttempt !== attempt || settledFor === attempt) return;
          settledFor   = attempt;
          frameArmed   = false;
          frameTrusted = false;
          if (remindTimer) { clearTimeout(remindTimer); remindTimer = null; }
          const success = qs('[data-pdp-remind-success]', this.section);
          const error   = qs('[data-pdp-remind-error]', this.section);
          if (ok) {
            if (form)    form.hidden    = true;
            if (success) success.hidden = false;
          } else {
            remindSubmit.disabled = false;
            if (error) error.hidden = false;
          }
        };

        // Bound once, and it has to survive a failed attempt so the shopper can retry.
        iframe?.addEventListener('load', () => {
          if (!frameArmed || !frameTrusted) return;
          finish(attempt, true);
        });

        form?.addEventListener('submit', (evt) => {
          const input = qs('[data-pdp-remind-input]', this.section);
          const email = (input ? input.value : '').trim();
          const error = qs('[data-pdp-remind-error]', this.section);

          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            // stopPropagation matters: Shopify's captcha script listens on document and, on a
            // form it has already claimed, submits it itself — which ignores preventDefault.
            evt.preventDefault();
            evt.stopPropagation();
            if (input) {
              input.style.outline = '2px solid #c0392b';
              setTimeout(function() { input.style.outline = ''; }, 1600);
            }
            return;
          }

          // The captcha script swallows the first submit on a form it hasn't tokenised yet and
          // resubmits it once it has, so this handler can run twice for one request. Only the
          // first pass opens an attempt; a later pass just upgrades the trust flag for the
          // attempt already in flight (the token may have landed between the two) and falls
          // through to the native post.
          if (settledFor !== attempt) {
            if (!frameTrusted) frameTrusted = isTokenised();
            return;
          }

          attempt++;
          const thisAttempt = attempt;
          frameArmed = true;
          // Set by Shopify's captcha script once hCaptcha has tokenised this form, which it does
          // on the first focusin inside it. If it is missing, that same script cancels this
          // submit and the post never happens, so a response could not be attributed to it.
          frameTrusted = isTokenised();

          // Clear any prior error state and lock the submit button for this attempt.
          if (error) error.hidden = true;
          remindSubmit.disabled = true;

          const productTitle = this.section.dataset.pdpTitle || '';
          const vendor       = this.section.dataset.pdpVendor || '';
          const productId    = this.section.dataset.pdpId || '';
          const variant      = this.currentVariant;
          const variantId    = variant ? String(variant.id) : '';
          const variantTitle = variant ? (variant.title || '') : '';
          const size         = variant ? (variant.option1 || variantTitle) : '';

          const subjectField = qs('[data-pdp-remind-subject]', this.section);
          const bodyField    = qs('[data-pdp-remind-body]', this.section);
          if (subjectField) subjectField.value = 'Restock request: ' + productTitle + (size ? ', size ' + size : '');
          if (bodyField) bodyField.value = [
            'New restock request received.',
            '',
            'Product:      ' + productTitle,
            'Brand:        ' + vendor,
            'Size/Variant: ' + (size || variantTitle),
            'Variant ID:   ' + variantId,
            'Customer:     ' + email,
            'URL:          ' + window.location.href,
            'Time:         ' + new Date().toUTCString(),
          ].join('\n');

          // ── Hook for back-in-stock app (Klaviyo, Appikon, etc.) ─────────
          // Fires unconditionally, independent of the /contact result below —
          // this is the customer-side subscription hook, not the owner notification.
          document.dispatchEvent(new CustomEvent('dc:restock-request', {
            bubbles: true,
            detail: { email: email, productTitle: productTitle, vendor: vendor, productId: productId, variantTitle: variantTitle, variantId: variantId, size: size, url: window.location.href },
          }));

          // Real <form> submit (targeting a hidden iframe) so Shopify's storefront
          // captcha-protection script can bind to the submit event the same way it
          // does for every other contact form on the theme. A bare fetch()/FormData
          // POST never fires a form submit event, so Shopify's backend rejects it
          // (400) for missing the captcha token that binding normally injects.
          //
          // Success is never assumed: it is shown only by the hoisted load listener above, and
          // only when this post carried a token. Everything else falls through to this timeout
          // and shows the error. Deliberately no preventDefault — the form posts itself.
          remindTimer = setTimeout(() => finish(thisAttempt, false), 12000);
        });
      }
    }

    _handleAdd() {
      if (!this.currentVariant || this.added) return;
      const variant = this.currentVariant;
      if (variant.available === false) return;

      // Lock synchronously so a second click during the network round-trip can't double-add.
      this.added = true;
      this._setAddEnabled(false);

      const sectionIds = qsa('cart-items-component')
        .map(el => el.dataset.sectionId)
        .filter(Boolean);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variant.id, quantity: 1, sections: sectionIds.join(',') }),
      })
        .then(r => r.json())
        .then(addResult => {
          if (addResult.status) throw new Error(addResult.message || 'Add to cart failed');
          return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(r => r.json())
            .then(cart => ({ cart, addResult }));
        })
        .then(({ cart, addResult }) => {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: String(variant.id),
              data: { itemCount: cart.item_count, sections: addResult.sections },
            },
          }));
          this._setAdded(true);
          setTimeout(() => {
            this._setAdded(false);
            const v = this.currentVariant;
            if (v) {
              this._setAddEnabled(v.available !== false, v.available === false);
            } else {
              this._setAddEnabled(false, false);
            }
          }, 1500);
        })
        .catch(err => {
          console.error('[DC Product] cart add failed', err);
          this.added = false;
          this._setAddEnabled(true);
        });
    }

    _setAdded(on) {
      this.added = on;
      [qs('[data-pdp-add]', this.section), qs('[data-pdp-sticky-add]', this.section)]
        .filter(Boolean)
        .forEach(btn => {
          btn.classList.toggle('added', on);
          if (on) {
            btn.innerHTML = IC.check + ' Added to bag';
          } else {
            btn.textContent = 'Add to bag';
          }
        });
    }

    /* ── Sticky bar ───────────────────────────────────────────── */
    _initStickyBar() {
      const bar    = qs('[data-pdp-sticky]', this.section);
      const anchor = qs('[data-pdp-add-anchor]', this.section);
      if (!bar || !anchor) return;

      const obs = new IntersectionObserver(
        ([entry]) => { bar.hidden = entry.isIntersecting; },
        { threshold: 0 }
      );
      obs.observe(anchor);
    }

    /* ── Vendor related products ──────────────────────────────── */
    _loadVendorRecs() {
      const section = qs('[data-pdp-vendor-recs]', this.section);
      if (!section) return;

      const vendor    = section.dataset.vendor;
      const productId = parseInt(section.dataset.productId, 10);
      const grid      = qs('[data-pdp-vendor-grid]', section);
      if (!vendor || !grid) return;

      fetch(
        `/search/suggest.json?q=${encodeURIComponent(vendor)}&resources[type]=product&resources[limit]=20`,
        { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
      )
        .then(r => r.json())
        .then(({ resources }) => {
          const products = (resources?.results?.products || [])
            .filter(p => p.id !== productId && p.vendor === vendor)
            .slice(0, 4);

          if (products.length === 0) return;

          // Fetch full product data in parallel to get back (second) image
          return Promise.all(
            products.map(p =>
              fetch(`/products/${p.handle}.js`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
                .then(r => r.json())
                .then(full => {
                  const imgUrl = img => (img && typeof img === 'object' ? img.src : img) || null;
                  return {
                    ...p,
                    priceCents:   typeof full.price === 'number' ? full.price : null,
                    compareCents: saleEventActive() && typeof full.compare_at_price === 'number' && full.compare_at_price > (full.price || 0) ? full.compare_at_price : null,
                    frontImg:     full.images?.length > 0 ? imgUrl(full.images[0]) : null,
                    backImg:      full.images?.length > 1 ? imgUrl(full.images[1]) : null,
                    variants:     full.variants || [],
                    description:  full.description || '',
                  };
                })
                .catch(() => ({ ...p, frontImg: null, backImg: null }))
            )
          );
        })
        .then(enriched => {
          if (!enriched) return;

          grid.innerHTML = enriched.map(p => this._renderVendorCard(p)).join('');

          // JS-driven crossfade: inline styles beat all CSS specificity
          grid.querySelectorAll('.dc-pcard--has-back').forEach(card => {
            const front = card.querySelector('.dc-pcard__img:not(.dc-pcard__img-back)');
            const back  = card.querySelector('.dc-pcard__img-back');
            if (!front || !back) return;
            card.addEventListener('mouseenter', () => {
              front.style.opacity = '0';
              back.style.opacity  = '1';
            });
            card.addEventListener('mouseleave', () => {
              front.style.opacity = '1';
              back.style.opacity  = '0';
            });
          });

          const section2 = qs('[data-pdp-vendor-recs]', this.section);
          if (section2) section2.hidden = false;
        })
        .catch(() => {});
    }

    _renderVendorCard(p) {
      const frontSrc = p.frontImg || (p.featured_image && p.featured_image.url) || '';
      const frontHtml = frontSrc
        ? `<img class="dc-pcard__img" src="${escHtml(frontSrc)}" alt="${escHtml(p.title)}" loading="lazy" />`
        : `<div class="dc-pcard__placeholder"></div>`;
      const backHtml = p.backImg
        ? `<img class="dc-pcard__img dc-pcard__img-back" src="${escHtml(p.backImg)}" alt="${escHtml(p.title)}" loading="eager" />`
        : '';
      const priceStr    = p.priceCents != null ? money(p.priceCents) : (p.price || '');
      const compareStr  = p.compareCents != null ? money(p.compareCents) : '';
      const variantsArr = (p.variants || []).map(v => ({ id: v.id, title: v.title, available: v.available }));
      const variantsJson = escHtml(JSON.stringify(variantsArr));
      const desc        = escHtml((p.description || '').replace(/<[^>]+>/g, '').slice(0, 200));
      const eyeIc = `<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>`;

      return `<a class="dc-pcard${p.backImg ? ' dc-pcard--has-back' : ''}" href="${escHtml(p.url)}"
  data-qv-title="${escHtml(p.title)}"
  data-qv-brand="${escHtml(p.vendor)}"
  data-qv-price="${escHtml(priceStr)}"
  data-qv-compare="${escHtml(compareStr)}"
  data-qv-image="${escHtml(frontSrc)}"
  data-qv-image-back="${escHtml(p.backImg || '')}"
  data-qv-desc="${desc}"
  data-qv-variants="${variantsJson}">
  <div class="dc-pcard__media">
    ${frontHtml}
    ${backHtml}
    <div class="dc-pcard__qv" data-qv-trigger role="button" tabindex="0" aria-label="Quick view ${escHtml(p.title)}">${eyeIc} Quick view</div>
  </div>
  <div class="dc-pcard__info">
    <p class="dc-pcard__brand">${escHtml(p.vendor)}</p>
    <p class="dc-pcard__name">${escHtml(p.title)}</p>
    <div class="dc-pcard__price-row">
      <span class="dc-pcard__price">${escHtml(priceStr)}</span>
    </div>
  </div>
</a>`;
    }
  }

  /* ── Boot ───────────────────────────────────────────────────── */
  function init() {
    const section = document.querySelector('[data-dc-product]');
    if (section) new DCProduct(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
